import React from 'react'
import { Container } from '@/components'
import styles from './Hero.module.css'
import clsx from 'clsx'

interface HeroProps {
  title?: string
  subtitle?: string
  backgroundImage?: string
  className?: string
  children?: React.ReactNode
}

const Hero: React.FC<HeroProps> = ({ 
  title, 
  subtitle, 
  backgroundImage,
  className,
  children
}) => {
  return (
    <div 
      className={clsx(styles.hero, className)}
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}}
    >
      <Container>
        {title && <h1 className={styles.heroTitle}>{title}</h1>}
        {subtitle && <p className={styles.heroSubtitle}>{subtitle}</p>}
        
        {children && (
          <div className={styles.heroContent}>
            {children}
          </div>
        )}
      </Container>
    </div>
  )
}

export default Hero 